import { FC } from 'react';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './validate-meia-entrada.styles';

interface IValidateMeiaEntrada {
  isNotFound?: boolean;
}

const ValidateMeiaEntrada: FC<IValidateMeiaEntrada> = ({ isNotFound = false }) => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();
  return (
    <Styles.Body>
      <Styles.Text>
        {translate(['INFORMATION', isNotFound ? 'MEIA_ENTRADA_NOT_FOUND' : 'LIMIT_MEIA_ENTRADA_1'])}
      </Styles.Text>
      {!isNotFound && <Styles.Text>{translate(['INFORMATION', 'LIMIT_MEIA_ENTRADA_2'])}</Styles.Text>}
      <Styles.BtnContainer>
        <Styles.CutomBtn onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'UNDERSTOOD'])}
        </Styles.CutomBtn>
      </Styles.BtnContainer>
    </Styles.Body>
  );
};

export default ValidateMeiaEntrada;
